module.exports = __webpack_public_path__ + "static/media/229.0c98cefc.webp";